export type Tenant = 'fpc' | 'fin'

export const useTenant = () => {
  const tenant = useCookie<Tenant>('tenant', { default: () => 'fpc' })
  const appConfig = useAppConfig()

  const apply = (t: Tenant) => {
    appConfig.ui.colors = { ...appConfig.ui.colors, primary: t }
  }

  if (import.meta.client) {
    apply(tenant.value)
    watch(tenant, apply)
  }

  return { tenant }
}
